document.addEventListener('DOMContentLoaded', function() {
    let activeTimeout = null;
    let currentDropdown = null;
    const dropdownParents = document.querySelectorAll('li.dropdown, [data-dropdown], .has-dropdown');
    
    // Function to show dropdown
    function showDropdown(dropdown) {
        clearTimeout(activeTimeout);
        if (currentDropdown && currentDropdown !== dropdown) {
            hideDropdown(currentDropdown);
        }
        currentDropdown = dropdown;
        dropdown.classList.add('open');
        dropdown.querySelector('.dropdown-menu').style.display = 'block';
    }
    
    // Function to hide dropdown
    function hideDropdown(dropdown) {
        dropdown.classList.remove('open');
        dropdown.querySelector('.dropdown-menu').style.display = 'none';
    }
    
    // Set up event listeners
    dropdownParents.forEach(parent => {
        const dropdown = parent.querySelector('.dropdown-menu');
        if (!dropdown) return;
        
        parent.addEventListener('mouseenter', () => {
            showDropdown(parent);
        });
        
        parent.addEventListener('mouseleave', () => {
            activeTimeout = setTimeout(() => {
                hideDropdown(parent);
                if (currentDropdown === parent) {
                    currentDropdown = null;
                }
            }, 150);
        });
        
        dropdown.addEventListener('mouseenter', () => {
            clearTimeout(activeTimeout);
        });
        
        dropdown.addEventListener('mouseleave', () => {
            activeTimeout = setTimeout(() => {
                hideDropdown(parent);
                if (currentDropdown === parent) {
                    currentDropdown = null;
                }
            }, 150);
        });
    });
});
